module.exports = __webpack_public_path__ + "img/ararat-reg-logo-mobile.2539ceee.svg";